import React from 'react'
import gql from 'graphql-tag'
import get from 'lodash.get'
import DeliveredUrl from 'components/shared/DeliveredUrl'
import DefaultProductStatus from '../../DefaultProductStatus'
import ProvideInput from './ProvideInput'
import ToggleTeaser from './ToggleTeaser'
import './index.scss'

const VideoProduct = ({product, viewer}) => {
  if (product.canProvideUserInput) {
    return (
      <ProvideInput
        product={product}
        productAvailability={viewer.broker.productAvailability}
        broker={viewer.broker}
      />
    )
  }

  const assets = product.assets.edges.map(({ node }) => node)

  if (product.state === 'delivered') {
    return (
      <>
        {assets.map((asset, i) => {
          const label = get(asset, 'labels[0]') || 'video'
          return (
            <DeliveredUrl
              key={asset.id}
              product={product}
              getDeliveredUrl={() => asset.url}
              getTexts={
                () => ({
                  product: 'video',
                  watchProduct: assets.length > 1 ? `Se video (${label})` : 'Se video',
                  copiedLink: 'Lenke er kopiert',
                  descriptions: i === 0 ? [
                    'Her har du en lenke til videoen din.',
                    'Du kan dele den med hvem du vil.'
                  ] : [],
                })
              }
            />
          )
        })}
      </>
    )
  }

  return (
    <>
      <DefaultProductStatus product={product} />
      {product.canOrderTeaser && (
        <ToggleTeaser product={product} />
      )}
    </>
  )
}

VideoProduct.fragment = gql`
  fragment VideoProduct on VideoProduct {
    videoVariant
    teaser
    teaserUnitPrice
    canOrderTeaser
    tasks {id, name, title, completed}
    features {id, name, value, optional}
    facts {id, name, value}
    booking {
      id
      resourceName
    }
    assets {
      edges {
        node {
          id
          state
          ...on UrlAsset {url, labels}
        }
      }
    }
  }
`

export default VideoProduct
